import { createContext, useState, useContext, ReactNode } from "react";

const MapModalContext = createContext<{
  visible: boolean;
  showMapModal: () => void;
  hideMapModal: () => void;
}>({ visible: false, showMapModal: () => {}, hideMapModal: () => {} });

export const MapModalProvider = ({ children }: { children: ReactNode }) => {
  const [visible, setVisible] = useState(false);

  const showMapModal = () => setVisible(true);
  const hideMapModal = () => setVisible(false);

  return (
    <MapModalContext.Provider value={{ visible, showMapModal, hideMapModal }}>
      {children}
    </MapModalContext.Provider>
  );
};

export const useMapModal = () => useContext(MapModalContext);
